<template>
  <div class="flex items-center space-x-1">
    <button 
      class="toolbar-btn" 
      @click="$emit('open-html-edit', editor.getHTML())" 
      :title="$t('EditHTML')"
    >
      <i class="fas fa-code"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AdvancedButtons',
  props: {
    editor: {
      type: Object,
      required: true
    }
  }
}
</script> 